import React, { Component } from 'react'
import DefaultLayout from '../../Layout/Default'
import Box from '../../../Shared/Box'
import { Col, Container, Row } from '../../../Shared/Grid'
import { withTranslation } from 'react-i18next'
import SendUnsentInvoices from './SendUnsent'

class InvoicesPage extends Component {

  render () {
    const { t } = this.props

    return (
      <DefaultLayout>
        <div className="ordersPage">
          <Box style={{ position: 'relative' }} hasInnerBackground={true}>
            <Container fluid gutterWidth={5}>
              <Row>
                <Col xs={12}>
                  <h3>{t('INVOICES')}</h3>
                </Col>
              </Row>
              <SendUnsentInvoices/>
              <Row>
              </Row>
            </Container>
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

export default withTranslation()(InvoicesPage)
